import { Component, OnDestroy, ChangeDetectorRef, NgZone } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
    title = '';

    window:any = <any>window;
    notification:any = new this.window.HPNotification({parent: 'body'});
    usher:any = this.window.usher;
    bigBucket:any = this.window.bigBucket;
    geoBucket:any = this.window.geoBucket;
    bucket:any = {};
    emitter:any = this.window.emitter;
    expanded:any = false;
    updateView:any = () => {
        setTimeout(() => this.cd.detectChanges(), 50);
    };

    constructor(private cd: ChangeDetectorRef, private ngZone: NgZone) {}

    ngAfterContentInit() {
        this.usher.config({
            onLogin: async (myself) => {
                try {
                    this.ngZone.run(async () => {
                        this.bucket = await this.bigBucket.findBucket(b => b.public_token == this.window.appInfo.buckets.bigBucket.settings);
                    });

                    //this.updateView();
                }
                catch(e){
                    console.log(e);
                    this.usher.logout();
                }
            },
            onLogout: async () => {
                this.bucket = {};
            }
        });

    }
}